import { ProfileEntity, ProfileResponse } from 'src/types'

export const ProfileTranslator = {
  toEntity: (response: ProfileResponse): ProfileEntity => {
    const { user } = response
    const { companyRoles, ...otherResponse } = user

    return {
      ...otherResponse,
      role: user.role,
      policies: user.policies ?? [],
      customRoles: companyRoles ?? [],
      keywords: user.keywords ?? [],
      projects:
        user.projects?.map(project => ({
          ...project,
          status: {
            ...project.status,
            priority: project.status.priority ?? undefined,
          },
          name: project.title,
          compassRole: project.role,
          isDeleting: project.isDeleting,
        })) ?? [],
      isExternal: false,
      projectCount: user.projects?.length ?? 0,
      createdAt: new Date(user.createdAt),
    }
  },
}
